const de = {
  "templateList.synchronize.preview.tooltip": "Synchronisation prüfen",
  "templateList.synchronize.preview.title": "Vorschau der Synchronisation",
  "templateList.synchronize.preview.description": "Die Prüfung verändert keine Daten. Sie zeigt, welche Änderungen die Synchronisation für diese Vorlagenversion aktuell vornehmen würde.",
  "templateList.synchronize.preview.loading": "Vorlagendaten werden abgeglichen …",
  "templateList.synchronize.preview.error": "Die Vorschau konnte nicht geladen werden. Bitte versuchen Sie es erneut.",
  "templateList.synchronize.preview.duplicateKeys": "Die Vorlage enthält doppelte Frage- oder Seiten-IDs. Die Synchronisation ist gesperrt, bis die IDs innerhalb der jeweiligen Elementart in der gesamten Vorlage eindeutig sind.",
  "templateList.synchronize.preview.blocked": "Synchronisation gesperrt",
  "templateList.synchronize.preview.duplicateId": "Doppelte ID",
  "templateList.synchronize.preview.locations": "Fundstellen in der Vorlage",
  "templateList.synchronize.preview.location.page": "Seite {index}",
  "templateList.synchronize.preview.location.question": "Frage {index}",
  "templateList.synchronize.preview.inactive": "Diese Vorlagenversion ist nicht mehr aktiviert. Bitte laden Sie die Vorlagenliste neu.",
  "templateList.synchronize.preview.notPublished": "Für diese Vorlagenversion sind noch keine veröffentlichten Daten vorhanden. Die Synchronisation würde keine Änderungen vornehmen.",
  "templateList.synchronize.preview.multipleSurveys": "Es wurden mehrere passende Vorlagenstrukturen gefunden. Die Synchronisation berücksichtigt den ersten Treffer.",
  "templateList.synchronize.preview.noChanges": "Die Daten stimmen überein. Es sind keine Änderungen erforderlich.",
  "templateList.synchronize.preview.summary": "{count, plural, one {# betroffenes Element} other {# betroffene Elemente}}",
  "templateList.synchronize.preview.entity": "Elementtyp",
  "templateList.synchronize.preview.CREATE": "Neu anlegen",
  "templateList.synchronize.preview.UPDATE": "Ändern",
  "templateList.synchronize.preview.details": "Änderungen im Detail",
  "templateList.synchronize.preview.comparison": "Vergleich der bisherigen und vorgesehenen Werte",
  "templateList.synchronize.preview.field": "Feld",
  "templateList.synchronize.preview.before": "Bisher",
  "templateList.synchronize.preview.after": "Vorgesehen",
  "templateList.synchronize.preview.unset": "Nicht gesetzt",
  "templateList.synchronize.preview.empty": "Leerer Text",
  "templateList.synchronize.preview.generated": "Wird beim Anlegen vergeben",
  "templateList.synchronize.preview.yes": "Ja",
  "templateList.synchronize.preview.no": "Nein",
  "templateList.synchronize.preview.retry": "Erneut prüfen",
  "templateList.synchronize.preview.entity.Survey": "Vorlagen",
  "templateList.synchronize.preview.entity.QuestionGroup": "Seiten",
  "templateList.synchronize.preview.entity.Question": "Fragen",
  "templateList.synchronize.preview.entity.Answer": "Antworten / Auswahloptionen",
  "templateList.synchronize.preview.entity.Indicator": "Indikatoren",
  "templateList.synchronize.preview.field.title": "Titel",
  "templateList.synchronize.preview.field.description": "Beschreibung",
  "templateList.synchronize.preview.field.name": "Interner Name",
  "templateList.synchronize.preview.field.surveyName": "Vorlagenname",
  "templateList.synchronize.preview.field.surveyRefId": "Vorlagen-ID",
  "templateList.synchronize.preview.field.version": "Version",
  "templateList.synchronize.preview.field.reportTemplateYear": "Vorlagenjahr / Monat",
  "templateList.synchronize.preview.field.pageKey": "Seitenschlüssel",
  "templateList.synchronize.preview.field.questionKey": "Frageschlüssel",
  "templateList.synchronize.preview.field.mandatory": "Pflichtfrage",
  "templateList.synchronize.preview.field.type": "Fragetyp",
  "templateList.synchronize.preview.field.orderIndex": "Reihenfolge",
  "templateList.synchronize.preview.field.page": "Zugeordnete Seite",
  "templateList.synchronize.preview.field.pageGid": "Seiten-ID",
  "templateList.synchronize.preview.field.rowName": "Interner Zeilenname",
  "templateList.synchronize.preview.field.rowText": "Zeilenbeschriftung",
  "templateList.synchronize.preview.field.rowKey": "Zeilenschlüssel",
  "templateList.synchronize.preview.field.colName": "Interner Spaltenname",
  "templateList.synchronize.preview.field.colText": "Spaltenbeschriftung",
  "templateList.synchronize.preview.field.colType": "Spaltentyp",
  "templateList.synchronize.preview.field.columnKey": "Spaltenschlüssel",
  "templateList.synchronize.preview.field.text": "Antwortbeschriftung",
  "templateList.synchronize.preview.field.value": "Antwortwert",
  "templateList.synchronize.preview.field.choiceKey": "Auswahlschlüssel",
  "templateList.synchronize.preview.field.predefined": "Vordefiniert",
  "templateList.synchronize.preview.field.isPredefined": "Vordefiniert",
  "templateList.synchronize.preview.field.indicatorKey": "Indikatorschlüssel",
  "templateList.synchronize.preview.field.indicatorRefId": "Indikator-ID",
  "templateList.synchronize.preview.field.shortName": "Kurzbezeichnung",
  "templateList.synchronize.preview.field.longName": "Langbezeichnung",
  "survey.editor.validation.check": "Vorlage prüfen",
  "survey.editor.validation.downloadJson": "JSON herunterladen",
  "survey.editor.validation.openWindow": "In neuem Fenster öffnen",
  "survey.editor.validation.popupBlocked": "Das neue Fenster konnte nicht geöffnet werden. Bitte erlauben Sie Pop-ups für diese Seite und versuchen Sie es erneut.",
  "survey.editor.validation.title": "Prüfergebnis der Vorlage",
  "survey.editor.validation.scope": "Geprüft: {pageCount} Abschnitte, {questionCount} Fragen und {triggerCount} Trigger im aktuellen Bearbeitungsstand.",
  "survey.editor.validation.summary": "{errors} Fehler und {warnings} Warnungen gefunden.",
  "survey.editor.validation.success": "Keine Auffälligkeiten bei IDs und gesetzten Triggern gefunden.",
  "survey.editor.validation.ids": "IDs und interne Namen",
  "survey.editor.validation.triggers": "Trigger",
  "survey.editor.validation.noIssues": "Keine Auffälligkeiten gefunden.",
  "survey.editor.validation.error": "Fehler",
  "survey.editor.validation.warning": "Warnungen",
  "survey.editor.validation.page": "Abschnitt",
  "survey.editor.validation.question": "Frage",
  "survey.editor.validation.column": "Spalte",
  "survey.editor.validation.row": "Zeile",
  "survey.editor.validation.option": "Option",
  "survey.editor.validation.missingColumnKey": "Die Spalte hat keinen Key (Spalten-ID).",
  "survey.editor.validation.missingRowKey": "Die Zeile hat keinen Key (Zeilen-ID).",
  "survey.editor.validation.missingOptionKey": "Die Antwortoption hat keinen Key (Antwort-ID).",
  "survey.editor.validation.duplicateKey": "Die ID „{value}“ ist mehrfach vergeben. Bitte eindeutige IDs verwenden.",
  "survey.editor.validation.duplicateName": "Der interne Name „{value}“ ist mehrfach vergeben. Zuordnungen können dadurch mehrdeutig sein.",
  "survey.editor.validation.unsupportedSource": "Dieser Fragetyp bzw. diese Frage ohne Antwortoptionen unterstützt keine Trigger.",
  "survey.editor.validation.invalidAnswer": "Der auslösende Antwortwert „{value}“ fehlt oder ist keine vorhandene Antwortoption.",
  "survey.editor.validation.unsupportedOperation": "Der Trigger verwendet einen nicht unterstützten Vergleich oder eine nicht unterstützte Aktion. Unterstützt werden EQ und ACTIVATE.",
  "survey.editor.validation.missingTarget": "Das Triggerziel „{value}“ fehlt oder wurde gelöscht. Bitte ein vorhandenes Ziel wählen.",
  "survey.editor.validation.ambiguousTarget": "Der Trigger verweist auf mehrere Ziele: Schlüssel oder Name sind mehrdeutig oder verweisen auf unterschiedliche Elemente.",
  "survey.editor.validation.staleReference": "Schlüssel oder interner Name des Triggerziels ist veraltet. Bitte das Ziel erneut auswählen.",
  "survey.editor.validation.wrongTargetType": "Der gespeicherte Zieltyp passt nicht zum referenzierten Abschnitt bzw. zur Frage.",
  "survey.editor.validation.selfReference": "Der Trigger verweist auf seine eigene Frage oder den Abschnitt, der sie enthält.",
  "survey.editor.validation.visibleTarget": "Das Ziel ist bereits standardmäßig sichtbar. Der Trigger hat daher keinen zusätzlichen Einblendeffekt.",
  "survey.editor.validation.backwardTarget": "Das Ziel steht vor der auslösenden Frage. Bitte prüfen, ob der Rückwärtsverweis beabsichtigt ist.",
  "survey.editor.validation.cycle": "Der Trigger ist Teil einer zyklischen Abhängigkeit. Bitte Erreichbarkeit und Verhalten beim Ändern von Antworten prüfen.",
  "templateList.synchronize.tooltip": "Vorlagenversion synchronisieren",
  "templateList.synchronize.success": "Die Vorlagenversion wurde erfolgreich synchronisiert.",
  "templateList.synchronize.duplicateKeys": "Synchronisation gesperrt: Die Vorlage enthält doppelte Frage- oder Seiten-IDs. Die Vorprüfung zeigt die betroffenen IDs und Fundstellen.",
  "templateList.synchronize.failed": "Die Vorlagenversion konnte nicht synchronisiert werden. Sie muss aktiviert und bereits veröffentlicht sein.",
  "login.headline": "Anmeldung",
  "login.loginButton": "Anmelden",
  "login.placeholder.username": "Benutzername",
  "login.placeholder.password": "Passwort",
  "login.error.0": "Service nicht verfügbar",
  "autoLogin.error.0": "Service nicht verfügbar",
  "login.error.401": "Ungültige E-Mail-Adresse oder ungültiges Kennwort. Wenn Sie Ihr Passwort nicht mehr zur Hand haben, klicken Sie auf \"Neues Passwort / Passwort vergessen\"",
  "login.error.500":
    "Es liegt eine technische Störung vor. Bitte versuchen Sie es später erneut. Vielen Dank für Ihre Geduld.",
  "login.error.blocked":
    "Das Benutzerkonto wurde gesperrt. Bitte nutzen Sie die Funktion „Neues Passwort“ unterhalb des Eingabefeldes, um das Benutzerkonto zu entsperren.",
  "login.forgot.password": "Neues Passwort / Passwort vergessen",
  "login.forgot.password.page.title": "Neues Passwort / Passwort vergessen",
  "login.reset.password.page.title": "Passwort zurücksetzen",
  "login.back.to.login.page": "Zurück zur Login Seite",
  "login.password.reset.request.success.message":
    "Es wurde eine E-Mail an sie versendet. Bitte öffnen Sie den darin enthaltenen Link um Ihr Passwort zurückzusetzen.",
  "login.token.validation.failed.message": "Der von Ihnen aufgerufene Link is ungültig/abgelaufen.",
  "login.please.specify.a.new.password": "Bitte vergeben Sie ein neues Passwort.",
  "login.please.enter.your.username":
    "Bitte geben Sie Ihre E-Mail-Adresse ein, um einen Link zum Setzen Ihres Passwortes zu erhalten",
  "login.password.resetted.success.message":
    "Ihr Passwort wurde erfolgreich zurückgesetzt. Sie können sich nun einloggen.",
  "login.password.reset.user.not.found.or.inactive": "Dieser Benutzer existiert nicht oder wurde deaktiviert.",
  "login.password.reset.temporary.user":
    "Dies ist ein temporärer Benutzer. Das Passwort kann nicht zurückgesetzt werden. Bitte verwenden Sie Ihren Zugangslink, um Sachberichte zu bearbeiten.",
  "login.password.reset.request.timeout":
    "Der E-Mail-Versand dauert aktuell zu lange. Bitte versuchen Sie es später erneut.",
  "login.password.reset.request.error":
    "Der Link zum Zurücksetzen des Passworts konnte nicht versendet werden. Bitte versuchen Sie es später erneut.",
  "autoLogin.error.401": "Ihre SAP Zugangsdaten konnten nicht zugeordnet werden. Bitte versuchen Sie es erneut",
  "create.user.error.400": "Benutzer ist bereits vorhanden.",
  "maintenance.title": "Wartungsarbeiten",
  "maintenance.text":
    "Das Monitoring-Tool ist wegen Wartungsarbeiten vorübergehend nicht verfügbar. Bitte versuchen Sie es später erneut.",
  "maintenance.login.disabled": "Der Login ist wegen Wartungsarbeiten vorübergehend deaktiviert.",

  "general.notification.downtime":
    "Bitte beachten Sie: Das Monitoring-Tool steht am Donnerstag, 02.07.2026 von 5:00 - 13:00 Uhr MESZ wegen Wartungsarbeiten nicht zur Verfügung. Wir bitten die Unannehmlichkeiten zu entschuldigen.",

  "app.header.help": "Hilfe",
  "header.logout.button": "Abmelden",
  "header.clear.survey.caches": "Caches löschen",
  "header.clear.survey.caches.success": "Die Survey-Caches wurden erfolgreich gelöscht.",
  "header.clear.survey.caches.error": "Die Survey-Caches konnten nicht gelöscht werden.",
  "app.footer.text": "© 2017, DAAD",
  "app.footer.banner.info": "Wir haben die Benutzeroberfläche des Monitoring-Tools für Sie modernisiert. Die Funktionalität hat sich nicht geändert;<br></br>Sie können Ihre Berichte wie gewohnt bearbeiten und einreichen. Das überarbeitete Handbuch finden Sie <link>hier</link>.",
  "app.common.All": "Alle",
  "app.common.Yes": "Ja",
  "app.common.No": "Nein",
  "app.common.Reset": "Zurücksetzen",
  "app.common.Language": "Sprache",
  "app.common.Create": "Erstellen",
  "app.common.Close": "Schließen",
  "app.common.Cancel": "Abbrechen",
  "app.common.Select": "Wählen",
  "app.common.Export": "Exportieren",
  "app.common.activate": "Aktivieren",
  "app.confirmDialog.defaultTitle": "Sind Sie sicher?",
  "app.common.msg.error": "Oops, es ist ein unbekannter Fehler aufgetreten. Bitte wenden Sie sich an monitoring@daad.de (Referat S12).",
  "app.common.msg.backend": "Oops, es ist ein unbekannter Fehler aufgetreten. Bitte wenden Sie sich an monitoring@daad.de (Referat S12).",
  "app.common.msg.success": "Ihr vorgang wurde erfolgreich durchgeführt!",
  "app.common.Apply": "Anwenden",
  "app.common.confirm.deletion": "Löschen bestätigen",
  "app.common.title.error": "Fehler",
  "app.common.title.backend": "Fehler",
  "app.common.title.warning": "Warnung",
  "app.common.title.info": "Information",
  "app.common.title.success": "Erfolg",
  "app.common.title.actions": "Aktionen",
  "app.common.no.data": "Keine Daten gefunden",
  "app.common.field.error.required": "Das ist ein Pflichtfeld.",
  "app.session.expired": "Sitzung abgelaufen",

  "app.validation.sizeMessage": "Datei ist zu groß.",
  "header.qa.message": "QS-System",
  "header.dev.message": "DEV-System",

  "app.common.Copy": "Kopie",
  "app.common.management": "Verwaltung",
  "app.common.role": "Rolle",
  "app.common.permissions": "Berechtigungen",
  "app.common.organizational.unit": "Förderbereich / Programm / Programminstanz / Projekt",

  "app.common.name": "Name",
  "app.common.name.english": "Name (englisch)",
  "app.common.name.german": "Name (deutsch)",

  "app.common.action.edit": "Bearbeiten",
  "app.common.action.deactivate": "Deaktivieren",
  "app.common.action.move": "Drag & Drop",
  "app.common.action.delete": "Löschen",
  "app.common.action.remove": "Entfügen",
  "app.common.action.cancel": "Abbrechen",
  "app.common.action.save": "Speichern",
  "app.common.action.show": "Anzeigen",
  "app.common.action.add": "Hinzufügen",
  "app.common.action.submit": "Absenden",
  "app.common.action.download": "Herunterladen",
  "app.common.action.take.over": "Übernehmen",
  "app.common.action.toggle.all": "Alle an/abwählen",
  "app.common.invalid_request": "Anfrage an den Service gescheitert.",
  "app.common.unsaved_changes": "Ungespeicherte Änderungen",

  "language.english": "Englisch",

  "language.german": "Deutsch",

  "user.welcome.message": "Willkommen",

  "user.surveyBuilder.saveButton": "Speichern",
  "user.surveyBuilder.surveyTitle": "Titel des Erhebungsinstruments",
  "user.surveyBuilder.surveyTitlePlaceHolder": "Titel hinzufügen",
  "user.surveyBuilder.reportTemplateYear": "Jahr und Monat der Musterberichtsvorlage",
  "user.surveyBuilder.reportTemplateYear.tooltip":
    "Mit diesem Jahr wird für die Programmauswertung gesteuert, welche Vorlage führend sein soll, wenn für ein Berichtsjahr mehrere Vorlagen aktiviert wurden. Die Vorlage mit dem jüngsten Datum ist führend. Falls in einem Berichtsjahr mehrere Vorlagen mit dem gleichen Jahr genutzt wurden, kann die führende Vorlage über den Monat innerhalb des Jahres festgelegt werden.",
  "survey.settings.save.thisVersion": "Nur für diese Version speichern",
  "template.year.edit": "Vorlagendatum ändern",
  "template.year.loadError": "Das Vorlagendatum konnte nicht geladen werden.",
  "template.year.saveError": "Das Vorlagendatum konnte nicht gespeichert oder die Anzeige nicht aktualisiert werden. Bitte öffnen Sie den Dialog erneut und prüfen Sie den Wert.",
  "survey.settings.save.followingVersions": "Für diese und alle folgenden Versionen speichern",
  "survey.settings.reportTemplateYearInvalid": "Bitte wählen Sie Jahr und Monat zwischen 1000-01 und 9999-12 aus.",
  "user.surveyBuilder.title": "Titel Erhebungsinstrument",
  "user.surveyBuilder.applicableFor": "Anwendbar für",
  "user.surveyBuilder.fundingArea": "Alle Förderbereiche",
  "user.surveyBuilder.program": "Alle Programme",
  "user.surveyBuilder.program.instance": "Alle Instanzen",
  "user.surveyBuilder.project": "Alle Projekte",
  "user.surveyBuilder.surveySettingsPanel.title": "Erhebungsinstrument erstellen",
  "user.surveyBuilder.surveySettingsPanel.copy.title": "Erhebungsinstrument kopieren",
  "user.surveyBuilder.surveySettingsPanel.edit.title": "Basisdaten ändern",

  "user.surveyView.prev": "Zurück",
  "user.surveyView.next": "Weiter",
  "user.surveyView.saveResult": "Speichern",
  "user.surveyView.menuPages": "Abschnitt",
  "user.surveyView.question": "Frage",
  "user.surveyView.from": "von",
  "user.surveyView.radio.otherChoice": "Bitte spezifizieren",
  "user.surveyView.radio.otherChoice.input": "Sonstiges",
  "user.surveyView.table.addRow": "Zeile hinzufügen",
  "user.surveyView.table.deleteRows": "Alle Zeilen löschen",
  "user.surveyView.table.loadPrevPeriodQuestionAnswers": "Vorjahresdaten laden",
  "user.surveyView.table.loadPreviousReportQuestionAnswers": "Letzte Berichtsdaten laden",
  "user.surveyView.table.uploadCSV": "CSV-Tabelle hochladen",
  "user.surveyView.table.uploadCSV.append": "Hinzufügen",
  "user.surveyView.table.uploadCSV.overwrite": "Ersetzen",
  "user.surveyView.table.downloadExcel": "Excel-Vorlage herunterladen",
  "user.surveyView.table.downloadExcel.hint":
    "Bitte speichern Sie die ausgefüllte Tabellenvorlage vor dem Hochladen als CSV-Datei ab. Eine Anleitung finde Sie im Handbuch.",
  "user.surveyView.table.uploadCSV.hint":
    "Sie haben die Möglichkeit, durch Hochladen einer CSV-Datei Zeilen hinzuzufügen. Bitte beachten Sie, dass Spaltenüberschriften sowie Auswahloptionen mit den vorgegebenen Werten in der Tabelle übereinstimmen müssen und zur korrekten Abbildung von Umlauten das **CSV UTF-8 Format** genutzt werden sollte. Näheres entnehmen Sie bitte dem Benutzerhandbuch.  **Bei umfangreichen Listen kann dieser Vorgang einige Minuten in Anspruch nehmen. Bitte schließen Sie nicht den Bericht oder den Browser.**",
  "user.surveyView.table.uploadCSV.success":
    "Die Daten konnten ermittelt werden ({rowCount} Zeilen).  Bitte wählen Sie aus, ob Sie die ermittelten Daten zur Tabelle **hinzufügen** möchten, oder ob Sie ggf. zuvor eingetragene oder aus dem Vorjahr geladene Daten **löschen und ersetzen** möchten.",
  "user.surveyView.table.uploadCSV.values.parseError":
    "Zeile {rowCount}, Spalte „{importColumn}“, Wert „{importValue}“",
  "user.surveyView.table.uploadCSV.columns.parseError": "Spaltenüberschrift „{importValue}“",
  "user.surveyView.table.uploadCSV.parseError":
    "Folgende Werte stimmen nicht mit den Anforderungen der Tabelle überein. Bitte prüfen Sie die Spalten- und Auswahloptionen in der CSV-Datei.",
  "user.surveyView.table.uploadCSV.parseWarning":
    "Folgende Spalten stimmen nicht mit den Anforderungen der Tabelle überein und werden beim Hochladen ignoriert.",
  "user.surveyView.table.mandatory.columns":
    "{completeColumns} von {columnLength} Pflichtspalten vollständig beantwortet. Angaben fehlen in folgenden Pflichtspalten:",
  "user.surveyView.table.rows.empty": "Keine Einträge",
  "user.surveyView.table.cell.empty": "Angabe fehlt",
  "user.surveyView.dropdown.choose": "Bitte auswählen",
  "user.surveyView.mandatory.field.tooltip":
    "Pflichtfragen sind mit „*“ markiert. Beachten Sie auch die mit „*“-markierten Spalten in Tabellen.",
  "user.surveyView.editing.disabled": "Der Sachbericht wurde eingereicht. Die Bearbeitung ist nicht mehr möglich.",
  "user.surveyView.editing.permission.disabled": "Sie haben keine Berechtigung zum Bearbeiten des Sachberichts.",
  "user.surveyView.editing.read.only1": " Der Bericht {surveyName} wird von {lockByUser} seit ",
  "user.surveyView.editing.read.only2": "  bearbeitet. Eine parallele Bearbeitung ist nicht möglich.",
  "user.surveyView.type.number": "Zahl",
  "user.surveyView.type.text": "Text",
  "user.surveyView.type.row": "Zeile",
  "user.surveyView.dialog.load.prev.result.not.found.title": "Keine Vorjahresdaten gefunden",
  "user.surveyView.dialog.load.prev.result.not.found.text":
    "Es wurden keine Vorjahresdaten für diese Frage gefunden, die übernommen werden können.",
  "user.surveyView.dialog.load.prev.result.title": "Vorjahresdaten gefunden",
  "user.surveyView.dialog.load.prev.result.text":
    "Es wurden Vorjahresdaten für diese Frage gefunden. Möchten Sie diese nun übernehmen und damit alle bestehenden Zeilen überschreiben? Bitte denken Sie daran, die geladenen Daten zu überprüfen und zu aktualisieren.",
  "user.surveyView.dialog.confirm.delete.all.rows": "Bitte bestätigen Sie das Löschen aller Zeilen.",
  "user.surveyView.dialog.confirm.delete.single.row": "Bitte bestätigen Sie das Löschen dieser Zeile.",
  "user.surveyView.question.activity.modal.title": "Aktivitätenmonitoring",
  "user.surveyView.question.activity.modal.measure": "Maßnahme",
  "user.surveyView.question.activity.modal.status": "Aktueller Stand",
  "user.surveyView.question.activity.modal.comment": "Kommentar",
  "user.surveyView.question.activity.filter.measurement": "Maßnahmenfilter",
  "user.surveyView.question.activity.filter.area": "Bereichsfilter",
  "user.surveyView.question.activity.filter.status": "Statusfilter",

  "app.validation.lengthMessage": "{currentLength, number} von möglichen {length, number} Zeichen",
  "app.validation.initialLengthMessage": "{text,number} von möglichen {length, number} Zeichen",
  "app.validation.maxLengthReached": "Eingabe nicht möglich: Maximal {length, number} Zeichen erlaubt.",
  "app.validation.rangeMessage": "Bitte geben Sie eine Zahl zwischen {minValue, number} und {maxValue, number} ein.",
  "app.validation.decimalMessage": "Erlaubte Dezimalstellen: {precision, number}",

  "templateList.filter": "Förderbereich",
  "templateList.title": "Erhebungsinstrumente",
  "templateList.new.template": "Neues Erhebungsinstrument",
  "templateList.templateTitle": "Titel",
  "templateList.version": "Version",
  "templateList.updated": "Geändert am",
  "templateList.activations.versionUpdated": "Letzte Bearbeitung dieser Version: {date}",
  "templateList.updatedBy": "Geändert von",
  "templateList.status": "Status",
  "templateList.language": "Sprache",
  "templateList.history": "Historie",
  "templateList.edit": "Bearbeiten",
  "templateList.preview": "Vorschau",
  "templateList.status.draft": "Entwurf",
  "templateList.status.active": "Aktiv",
  "templateList.sync.released": "Synced",
  "templateList.sync.unreleased": "Nicht synced",

  "templateList.tooltip.history": "Historie",
  "templateList.tooltip.activate": "Aktivieren",
  "templateList.tooltip.activations.overview": "Übersicht Aktivierungen",
  "templateList.tooltip.sync": "Sync",
  "templateList.tooltip.edit": "Bearbeiten",
  "templateList.tooltip.compare": "Vergleichen",
  "templateList.tooltip.copy": "Kopieren",
  "templateList.tooltip.delete": "Löschen",
  "templateList.tooltip.delete.activatedVersions": "Löschen ist nicht möglich, da aktivierte Versionen dieser Vorlage existieren.",
  "templateList.tooltip.delete.disabled": "Es ist nicht möglich, eine aktive Vorlage zu löschen.",
  "templateList.tooltip.basic.edit": "Basisdaten ändern",
  "templateList.tooltip.survey.preview": "Vorschau",
  "templateList.tooltip.pdf.create": "PDF erstellen",

  "templateList.compare.title": "Surveyvorlagen vergleichen",

  "templateList.activations.activation": "Aktivierung",
  "templateList.activations.lastVersionActivation": "Letzte Aktivierung dieser Version",
  "templateList.activations.activations": "Aktivierungen",
  "templateList.activations.preactivations": "Voraktivierungen",
  "templateList.activations.previous": "Bisherige",
  "templateList.activations.template.title": "Titel des Erhebungsintruments",
  "templateList.activations.activation.title": "Titel Erhebungsinstrument bei Aktivierung",
  "templateList.activations.program.instance": "Programm/Instanz",
  "templateList.activations.program.instance.foreignid": "ID FP/FPI",
  "templateList.activations.reportingYear": "Berichtsjahr",
  "templateList.activations.amount": "Anzahl",
  "templateList.activations.semester.program.amount": "Anzahl aktivierte Berichte",

  "indicatorList.indicatorModalPanel.title.placeholder": "ID",
  "indicatorList.new.indicator": "Indikator hinzufügen",
  "indicatorList.edit.indicator": "Indikator bearbeiten",
  "indicatorList.title": "Indikatoren",
  "indicatorList.ID": "ID",
  "indicatorList.IndicatorShortVersion": "Kurzform Indikator",
  "indicatorList.IndicatorLongVersion": "Langform Indikator",
  "indicatorList.IndicatorShort": "Kurzform",
  "indicatorList.IndicatorLong": "Langform",
  "indicatorList.IndicatorShort.english": "Kurzbeschreibung (englisch)",
  "indicatorList.IndicatorLong.english":
    "Beschreibung des Indikators gemäß Indikatoren-Toolbox (inkl. Differenzierungen) (englisch)",
  "indicatorList.IndicatorShort.german": "Kurzbeschreibung (deutsch)",
  "indicatorList.IndicatorLong.german":
    "Beschreibung des Indikators gemäß Indikatoren-Toolbox (inkl. Differenzierungen) (deutsch)",
  "indicatorList.Level": "Ebene",
  "indicatorList.Indicator": "Indikator",
  "indicatorList.select": "Förderbereich",
  "indicatorList.program": "Programm",
  "indicatorList.fundingArea": "Förderbereich",
  "indicatorList.edit": "Bearbeiten",
  "indicatorList.id.500": "ID bereits vergeben",
  "indicatorList.id.empty": "ID darf nicht leer sein. Bitte ID auswählen",
  "indicatorList.fundingArea.empty": "Bitte wählen Sie einen Förderbereich",
  "indicatorList.programs.all": "Alle Programme",
  "indicatorList.tooltip.edit": "Bearbeiten",

  "indicator.management.page.title": "Indikatorenverwaltung",
  "indicator.management.new.action.field": "Wirkungsfeld anlegen",
  "indicator.management.new.active.element": "Wirkelement anlegen",
  "indicator.management.new.indicator": "Indikator anlegen",
  "indicator.management.edit.action.field": "Wirkungsfeld bearbeiten",
  "indicator.management.edit.active.element": "Wirkelement bearbeiten",
  "indicator.management.edit.indicator": "Indikator bearbeiten",
  "indicator.management.action.field": "Wirkungsfeld",
  "indicator.management.all.action.fields": "Alle Wirkungsfelder",
  "indicator.management.all.results": "Alle Wirkelemente",
  "indicator.management.choose.action.field": "Wirkungsfeld auswählen...",
  "indicator.management.result": "Wirkelement",
  "indicator.management.indicator": "Indikator",
  "indicator.management.question": "Frage",
  "indicator.management.action.fields": "Wirkungsfelder",
  "indicator.management.action.field.or.fields": "Wirkungsfeld(er)",
  "indicator.management.results": "Wirkelemente",
  "indicator.management.indicators": "Indikatoren",
  "indicator.management.questions": "Fragen",
  "indicator.management.table.header.questions": "Abfrage",
  "indicator.management.question.preview": "Für eine Vorschau bitte hier klicken",
  "indicator.management.result.description.german": "Beschreibung (deutsch)",
  "indicator.management.result.description.english": "Beschreibung (englisch)",
  "indicator.management.confirm.delete.action.field": "Bitte bestätigen Sie das Löschen des Wirkungsfeldes.",
  "indicator.management.confirm.delete.result": "Bitte bestätigen Sie das Löschen des Wirkelements.",
  "indicator.management.confirm.delete.indicator": "Bitte bestätigen Sie das Löschen des Indikators.",
  "indicator.management.delete.action.field.not.possible":
    "Das Wirkungsfeld konnte nicht gelöscht werden, da noch verknüpfte Wirkelemente existieren.",
  "indicator.management.delete.result.not.possible":
    "Das Wirkelement konnte nicht gelöscht werden, da noch verknüpfte Indikatoren existieren.",
  "indicator.management.delete.indicator.not.possible":
    "Der Indikator konnte nicht gelöscht werden, da noch verknüpfte Fragen existieren.",
  "indicator.management.indicator.title.german": "Titel Indikator (deutsch)",
  "indicator.management.indicator.title.english": "Titel Indikator (englisch)",
  "indicator.management.indicator.question.german": "Frage (deutsch)",
  "indicator.management.indicator.question.english": "Frage (englisch)",
  "indicator.management.indicator.code.invalid": "Diese ID ist schon vergeben",

  "survey.settings.choose.period": "Berichte erstellen für Berichtszeitraum",
  "survey.settings.activate.survey": "Berichtsvorlage aktivieren",
  "survey.settings.activate.survey.info":
    "Für das gewählte Programm wurden {numProjects} Projekte gefunden. Nach Aktivierung des Sachberichts sind keine Änderungen an der Vorlage mehr möglich.",
  "survey.settings.activate.survey.warning": "Sind Sie sicher, dass Sie Berichte für alle Projekte erstellen möchten?",
  "survey.settings.create.reports": "Berichte erstellen für",

  "dialog.leave.report": "Ihre Angaben wurden gespeichert",
  "dialog.leave.message":
    "Ihre Änderungen gehen möglicherweise durch das Verlassen dieser Seite verloren. Möchten Sie die Seite trotzdem verlassen?",
  "dialog.leave.message.with.details": "Ungespeicherte Änderungen in Zeile(n): {rows}. Wollen Sie abbrechen und diese Änderungen verwerfen?",
  "dialog.leave.with.saving": "Speichern und Beenden",
  "dialog.leave.without.saving": "Beenden",
  "dialog.dismiss": "Abbrechen",
  "dialog.delete": "Löschen",
  "dialog.template.delete.title": "Instrument löschen",
  "dialog.template.delete.text": "Soll dieses Erhebungsinstrument wirklich gelöscht werden?",
  "dialog.respondents.overview.delete.title": "Bericht löschen",
  "dialog.respondents.overview.delete.text": "Soll dieser Bericht wirklich gelöscht werden?",
  "dialog.respondents.overview.start.conversion.title": "ZIP/PDF erstellen",
  "dialog.respondents.overview.start.conversion.text": "Es gibt {count} Berichte, die in eine ZIP-Datei mit PDF-Dokumenten umgewandelt werden können. Dies kann einige Zeit in Anspruch nehmen. Möchten Sie den Vorgang starten?",

  "dialog.leave": "Erhebungsinstrumente verlassen",
  "dialog.template.leave.title": "Erhebungsinstrumente verlassen",
  "dialog.template.leave.text":
    "Falls Sie die Bearbeitung der Erhebungsinstrumente ohne Speichern verlassen, werden Ihre Änderungen verworfen.",

  "dialog.leave.runner":
    "Sie können mir Ihrer Bearbeitung jetzt oder zu einem späteren Zeitpunkt fortfahren. Um den finalen Bericht an den DAAD zu senden, gehen Sie bitte auf die Detailseite und nutzen dort den Button „Einreichen“.",
  "dialog.leave.runner.overview": "Fortfahren",
  "dialog.leave.runner.details": " Zur Detailseite",

  "runner.table.dialog.title.new": "Erstelle neue Tabellenzeile",
  "runner.table.dialog.title.edit": "Ändere Tabellenzeile",
  "runner.error.dialog.title": "Es ist ein Fehler aufgetreten",
  "runner.error.dialog.button.confirm": "OK",
  "runner.error.2.0.6":
    "Dieser Sachbericht wurde zwischenzeitlich verändert und kann nicht mehr gespeichert werden. Bitte öffnen Sie den Sachbericht erneut über die Übersicht.",
  "runner.error.1.0.1":
    "Der Sachbericht konnte nicht gespeichert werden. Bitte überprüfen Sie Ihre Internet-Verbindung.",

  "overview.survey_templates": "Erhebungsinstrumente",
  "overview.survey": "Berichterstattung",
  "overview.report": "Auswertung",
  "overview.admin": "Verwaltung",
  "overview.indicators": "Indikatoren",
  "overview.users": "Benutzer",
  "overview.projects": "Projekte",
  "overview.respondents": "Respondenten",
  "overview.lists": "Listen",
  "overview.masterdata": "Stammdaten",
  "overview.roles": "Rollen",
  "overview.profile": "Profil",
  "overview.user.manual": "Handbuch",
  "overview.user.manual.lecturer": "Handbuch für Lektorinnen und Lektoren",
  "overview.user.faq": "FAQ",

  "confirmDialog.title": "Dialog",
  "confirmDialog.text": "Sind Sie sicher?",
  "confirmDialog.confirmLabel": "Ja",
  "confirmDialog.dismissLabel": "Nein",
  "confirmDialog.ok": "Ok",
  "confirmDialog.cancel": "Abbrechen",

  "survey.editor.question": "Frage",
  "survey.editor.page.key": "Abschnitt-ID",
  "survey.editor.question.key": "Fragen-ID",
  "survey.editor.choice.key": "Antwort-ID",
  "survey.editor.column.key": "Spalten-ID",
  "survey.editor.row.key": "Zeilen-ID",
  "survey.editor.page.title": "Abschnittstitel",
  "survey.editor.description": "Beschreibung",
  "survey.editor.infotext": "Infotext",
  "survey.editor.title.survey.edit": "Titel des Erhebungsinstruments",
  "survey.editor.exclusive": "Exklusiv",
  "survey.editor.exclusive.info":
    "Wenn Projektverantwortliche eine exklusive Antwortoption auswählen, können sie keine weitere mehr auswählen. Schreiben Sie daher in die Antwortoption eine entsprechende Information hinzu. Beispiel: „Sprachkurse (Exklusive Antwortoption)“",
  "survey.editor.save": "Speichern",
  "survey.editor.preview": "Vorschau",
  "survey.editor.title.edit": "Titel und Beschreibung bearbeiten",
  "survey.editor.choices": "Antwortoptionen",
  "survey.editor.confirm.page.deletion": "Sind Sie sicher, dass Sie diesen Abschnitt löschen möchten?",
  "survey.editor.rename.page": "Abschnitt bearbeiten",
  "survey.editor.confirm.question.deletion": "Sind Sie sicher, dass Sie diese Frage löschen möchten?",
  "survey.editor.confirm.question.deletion.library":
    "Diese Frage ist mit der Fragenbibliothek verknüpft. Die entsprechende Frage in der Bibliothek wird beim nächsten „SYNC“ gelöscht.",
  "survey.editor.question.types": "Fragetypen",
  "survey.editor.confirm": "Bestätigen",
  "survey.editor.cancel": "Abbrechen",
  "survey.editor.toolbox.text": "Textfeld",
  "survey.editor.toolbox.date": "Datum",
  "survey.editor.toolbox.comment": "Textbox",
  "survey.editor.toolbox.infoMessage": "Infotext",
  "survey.editor.toolbox.checkbox": "Auswahl mehrfach",
  "survey.editor.toolbox.radio": "Auswahl einfach",
  "survey.editor.toolbox.radioButton": "Radiobutton",
  "survey.editor.toolbox.radio.other": "Antwortoption „Sonstiges“",
  "survey.editor.toolbox.radio.other.info":
    "Diese Antwortoption bietet Projektverantwortlichen die Möglichkeit‚ das „Sonstige“ per Freitext näher zu beschreiben.",
  "survey.editor.toolbox.dropdown": "Dropdown",
  "survey.editor.toolbox.predefinedList": "Vordefinierte Liste",
  "survey.editor.toolbox.predefinedList.info":
    "Hierüber können Sie verschiedene, von S12 administrierte Auswahllisten als Antwortoption hinterlegen.",
  "survey.editor.toolbox.number": "Zahl",
  "survey.editor.toolbox.matrixChoice": "Matrix",
  "survey.editor.toolbox.matrixSingleChoice": "Matrix einfach",
  "survey.editor.toolbox.matrixMultipleChoice": "Matrix mehrfach",
  "survey.editor.toolbox.table": "Tabelle",
  "survey.editor.toolbox.upload": "Datei",

  "survey.editor.toolbox.projectData": "Projekt Stammdaten",
  "survey.editor.toolbox.projectData.information": "Informationen zum Projekt",
  "survey.editor.toolbox.projectData.projectName": "Projektbezeichnung",
  "survey.editor.toolbox.projectData.projectNumber": "Projekt-ID",
  "survey.editor.toolbox.projectData.fundingSum": "Höhe der Gesamtzuwendung",
  "survey.editor.toolbox.projectData.institution": "Zuwendungsempfänger",
  "survey.editor.toolbox.projectData.faculty": "Organisationsbereich",
  "survey.editor.toolbox.projectData.emptyInfo": "Keine Daten verfügbar",
  "survey.editor.toolbox.projectData.hint":
    "In diesem Abschnitt werden die Daten des Projekts und die Kontaktinformationen der Ansprechpartner angezeigt.",
  "survey.editor.toolbox.projectData.contact": "Ansprechpersonen",
  "survey.editor.toolbox.projectData.no.contact": "Keine Ansprechpersonen vorhanden.",
  "survey.editor.toolbox.projectData.name": "Name",
  "survey.editor.toolbox.projectData.firstName": "Vorname",
  "survey.editor.toolbox.projectData.email": "E-Mail",
  "survey.editor.toolbox.projectData.role": "Rolle",
  "survey.editor.toolbox.projectData.firstFundingYear": "Förderbeginn",
  "survey.editor.toolbox.projectData.lastFundingYear": "Förderende",
  "survey.editor.toolbox.projectData.numberOfFundingYear": "Anzahl der Förderjahre",
  "survey.editor.toolbox.projectData.reportingYear": "Berichtsjahr (entspricht Haushaltsjahr)",
  "survey.editor.toolbox.projectData.assistent": "Projektassistent",
  "survey.editor.toolbox.projectData.lead": "Projektverantwortlicher",
  "survey.editor.toolbox.projectData.project_assistant": "Projektassistent",
  "survey.editor.toolbox.projectData.project_responsible": "Projektverantwortlicher",

  "survey.editor.toolbox.staticTable": "Statische Tabelle",
  "survey.editor.toolbox.staticTable.unnamed": "unbenannt",
  "survey.editor.toolbox.dynamicTable": "Dynamische Tabelle",
  "survey.editor.table.number": "Zahl",
  "survey.editor.table.text": "Textfeld",
  "survey.editor.table.date": "Datum",
  "survey.editor.table.singleChoice": "Auswahl einfach",
  "survey.editor.activity.list": "Aktivitätenliste",
  "survey.editor.table.multipleChoice": "Auswahl mehrfach",
  "survey.editor.table.dropDown": "Dropdown",
  "survey.editor.required": "Pflichtfeld",
  "survey.editor.required.info":
    "Aktivieren Sie diesen Schieberegler, um eine Frage als Pflichtfrage festzulegen, wenn diese Information essenziell ist. Legen Sie eine Frage nur dann als Pflichtfrage fest, wenn alle Hochschulen Daten dazu eingeben können. Zusätzlich oder alternativ können Sie innerhalb von Tabellen einzelne Spalten als Pflichtfelder definieren.",
  "survey.editor.visible": "Sichtbar",
  "survey.editor.indicator": "Indikator zuweisen",
  "survey.editor.text.maxLength": "Max. Zeichen",
  "survey.editor.text.number.till": "bis",
  "survey.editor.text.number.from": "von",
  "survey.editor.text.number.range": "Wertebereich ",
  "survey.editor.text.number.suffix": "Suffix",
  "survey.editor.text.number.decimal": "Dezimalstellen",
  "survey.editor.matrix.column.choices": "Spalten",
  "survey.editor.matrix.column.choice": "Spalte",
  "survey.editor.matrix.row.choices": "Zeilen ",
  "survey.editor.text.maxSize": "Max",
  "survey.editor.text.mb": "MB",
  "survey.editor.evaluate.since.funding.started": "Frage seit Förderbeginn auswerten",
  "survey.editor.evaluate.since.funding.started.info":
    "Aktivieren Sie diesen Schieberegler, wenn der Indikator laut Indikatorenkatalog „seit Förderbeginn“ erhoben wird.",
  "survey.editor.load.previous.data.enabled": "„Vorjahresdaten laden“ möglich",
  "survey.editor.load.previous.data.enabled.info":
    "Aktivieren Sie diesen Schieberegler, damit PVs/PAs ihre Antworten zu einer Frage aus dem Vorjahresbericht laden können (V.a. sinnvoll bei Fragen, die seit Förderbeginn erhoben werden und bei Fragen, deren Antworten von Jahr zu Jahr kaum oder nur wenige Anpassungen erfordern).",
  "survey.editor.upload.csv.enabled": "„CSV-Tabelle hochladen“ möglich",
  "survey.editor.upload.csv.enabled.info":
    "Aktivieren Sie diesen Schieberegler, damit PVs/PAs eine Excel-Vorlage herunterladen, ausfüllen und anschließend als csv-Datei ins Tool hochladen zu können (V.a. sinnvoll bei Tabellen, mit denen die Hochschulen unterjährig arbeiten können, z.B. zu Bewerbungen).",
  "survey.editor.question.configuration": "Konfiguration",
  "survey.editor.tooltip.page.add": "Abschnitt hinzufügen",
  "survey.editor.tooltip.page.edit": "Abschnitt bearbeiten",
  "survey.editor.tooltip.page.delete": "Abschnitt löschen",
  "survey.editor.tooltip.page.visibility": "Sichtbarkeit (Trigger-Funktion)",
  "survey.editor.tooltip.question.visibility": "Sichtbarkeit (Trigger-Funktion)",
  "survey.editor.tooltip.question.library": "Frage zu meiner Bibliothek hinzufügen",
  "survey.editor.tooltip.question.library.indicator": "Diese Frage ist mit zumindest einem Standardindikator verknüpft.",
  "survey.editor.tooltip.question.libraryQuestion": "Diese Frage wurde aus der Indikatoren-Toolbox hinzugefügt.",
  "survey.editor.tooltip.question.myLibraryQuestion": "Diese Frage wurde aus Meiner Fragenbibliothek hinzugefügt.",
  "survey.editor.tooltip.question.trigger": "Trigger bearbeiten",
  "survey.editor.tooltip.question.trigger.add": "Trigger hinzufügen",
  "survey.editor.tooltip.question.trigger.delete": "Trigger löschen",
  "survey.editor.tooltip.question.delete": "Frage löschen",
  "survey.editor.tooltip.question.move": "Frage verschieben",
  "survey.editor.tooltip.table.column.edit": "Spalte bearbeiten",
  "survey.editor.tooltip.table.row.edit": "Zeile bearbeiten",
  "survey.editor.tooltip.question.copy": "Frage kopieren",
  "survey.editor.tooltip.table.column.add": "Spalte hinzufügen",
  "survey.editor.tooltip.table.column.delete": "Spalte löschen",
  "survey.editor.tooltip.table.column.move": "Spalte verschieben",
  "survey.editor.tooltip.table.row.add": "Zeile hinzufügen",
  "survey.editor.tooltip.table.row.delete": "Zeile löschen",
  "survey.editor.tooltip.table.row.move": "Zeile verschieben",
  "survey.editor.tooltip.indicator.delete": "Indikator löschen",

  "survey.editor.indicators.none": "Keine Indikatoren",
  "survey.editor.predefined.list.countries": "Liste Länder",
  "survey.editor.predefined.list.regions": "Liste Regionen",
  "survey.editor.predefined.list.country_reduced":
    "Liste Mitgliedstaaten der „Organisation für islamische Zusammenarbeit“",
  "survey.editor.predefined.list.country": "Liste Länder",
  "survey.editor.predefined.list.region": "Liste Regionen",
  "survey.editor.predefined.list.field_of_study": "Liste Fächergruppen",
  "survey.editor.predefined.list.subject_of_study": "Liste Studienfächer",
  "survey.editor.predefined.list.degree": "Liste Studienabschlüsse",
  "survey.editor.predefined.list.subject_of_study_teacher": "Liste Studienfächer Lehramt",
  "survey.editor.predefined.list.states": "Liste Bundesländer",
  "survey.editor.trigger.set_trigger": "Trigger setzen",
  "survey.editor.trigger.answer": "Bei Antwort",
  "survey.editor.trigger.make_visible": "Folgende Frage / Abschnitt anzeigen",
  "survey.editor.trigger.target.placeholder": "Bitte wählen Sie eine Frage oder Abschnitt aus",
  "survey.editor.trigger.target.group.pages": "Abschnitte",
  "survey.editor.trigger.target.group.questions": "Fragen",
  "survey.editor.trigger.target.group.visible": "Sichtbar",
  "survey.editor.trigger.target.group.missing": "Nicht gefunden",
  "survey.editor.trigger.target.visible": "sichtbar",
  "survey.editor.trigger.target.missing": "nicht gefunden",
  "survey.editor.trigger.warning.target_visible":
    "Dieses Ziel ist bereits sichtbar. Ein Trigger macht es daher im Fragebogen nicht zusätzlich sichtbar.",
  "survey.editor.trigger.warning.target_missing":
    "Dieses Ziel wird vom Trigger referenziert, existiert aber nicht mehr als Frage oder Abschnitt.",
  "survey.editor.message.template_saved": "Vorlage wurde erfolgreich gespeichert.",
  "survey.editor.message.template_saved.question.keys.message": "Ihre Berichtsvorlage wurde gespeichert. Sie enthält jedoch doppelte Fragen-IDs, sodass sie nicht aktiviert werden kann. Für Fragen wenden Sie sich an S12.",
  "survey.editor.message.template_saved.duplicate.keys.message": "Ihre Berichtsvorlage wurde gespeichert. Sie enthält jedoch doppelte Abschnitt- oder Fragen-IDs, sodass sie nicht aktiviert werden kann. Für Fragen wenden Sie sich an S12.",
  "survey.editor.message.question_saved": "Frage wurde erfolgreich in der Bibliothek gespeichert.",
  "survey.editor.message.template_synced": "Fragen wurden erfolgreich mit der Fragenbibliothek synchronisiert.",
  "survey.editor.message.version.compare.warning.message": "Es gibt keine frühere Version dieses Sachberichts, die aktiviert wurde, oder die letzte aktivierte Version ist die aktuelle. Es wird ein Vergleich mit der vorletzten aktivierten Version angezeigt.",
  "survey.editor.message.version.compare.warning.title": "Hinweis Versionenvergleich",
  "survey.editor.question.linked.indicators":
    "Diese Frage ist verknüpft mit folgenden Indikatoren und ist nur beschränkt editierbar:",

  "survey.editor.date.year": "Jahr",
  "survey.editor.date.month": "Monat",
  "survey.editor.date.day": "Tag",

  "respondents.overview.download.pdf.reports.title": "Download PDF-Berichte",
  "respondents.overview.download.pdf.reports.report.type": "Berichtstyp",
  "respondents.overview.download.pdf.reports.submission.date": "Einreichdatum",

  "respondents.overview.pageTitle": "Überblick Berichterstattung",
  "respondents.overview.button.new.report": "Neuer Bericht",
  "respondents.overview.button.report.status": "Statusbericht",
  "respondents.overview.button.pdf.reports": "PDF-Berichte",
  "respondents.overview.title": "Titel",
  "respondents.overview.universityName": "Hochschule",
  "respondents.overview.templateTitle": "Titel Bericht",
  "respondents.overview.fundingArea": "Förderbereich",
  "respondents.overview.program": "Programm",
  "respondents.overview.instance": "Programminstanz",
  "respondents.overview.location": "Standort",
  "respondents.overview.project": "Projekt",
  "respondents.overview.reportPeriod": "Berichtszeitraum",
  "respondents.overview.status": "Status",
  "respondents.overview.lastEdit": "Zuletzt bearbeitet",
  "respondents.overview.tooltip.edit": "Bericht bearbeiten",
  "respondents.overview.tooltip.status": "Status Berichterstattung",
  "respondents.overview.project.id": "Projektkennziffer",
  "respondents.overview.lecturer": "Lektor/in",
  "respondents.overview.project.id.do.not.exist": "Nicht vorhanden",
  "respondents.overview.period.name": "Hochschuljahr",

  "respondents.overview.report.activation.title": "Berichtsvorlage",
  "respondents.overview.report.activation.project": "Standort",
  "respondents.overview.report.activation.choose.project": "Bitte wählen Sie einen Standort aus.",
  "respondents.overview.report.activation.choose.period": "Bitte wählen Sie einen Berichtszeitraum aus.",
  "respondents.overview.report.activation.choose.template": "Bitte wählen Sie eine Berichtsvorlage aus.",
  "respondents.overview.report.activation.no_templates_available": "Für den ausgewählten Standort und Berichtszeitraum stehen keine aktivierbaren Berichtsvorlagen zur Verfügung.",
  "respondents.overview.report.activation.template_must_be_choosen": "Bitte wählen Sie eine Vorlage",
  "respondents.overview.report.activation.succeeded": "Ihre Berichtsvorlage wurde erfolgreich aktiviert.",
  "respondents.overview.report.activation.not_published": "Die Berichtsvorlage ist für den Berichtszeitraum bereits aktiviert.",
  "respondents.overview.report.activation.invalid": "Die Vorlage konnte nicht aktiviert werden. Bitte wenden Sie sich an S12.",

  "respondents.overview.status.IN_PROGRESS": "In Bearbeitung",
  "respondents.overview.status.COMPLETED": "Abgeschlossen",
  "respondents.overview.status.SENT": "Eingereicht",
  "respondents.overview.status.CLOSED": "Abgeschlossen",
  "respondents.overview.status.NEW": "Neu",
  "respondents.overview.status.OBSOLETE": "Obsolet",
  "respondents.overview.search.placeholder": "Suche...",
  "respondents.overview.filter.label": "Filter",
  "respondents.overview.filter.all": "Alle",

  "respondents.detail.page": "Abschnitt",
  "respondents.detail.page.unknown": "Unbekannt",
  "respondents.detail.progress": "Fortschritt",
  "respondents.detail.required.questions": "Alle Pflichtfragen beantwortet?",
  "respondents.detail.firstEdit": "Zuerst bearbeitet",
  "respondents.detail.respondent": "Verantwortlich",
  "respondents.detail.edit": "Bearbeiten",
  "respondents.detail.status": "Status: ",
  "respondents.detail.lastEditAt": "Zuletzt bearbeitet am",
  "respondents.detail.editBy": "von",
  "respondents.detail.submittedAt": "Eingereicht am",
  "respondents.detail.printButton": "Drucken",
  "respondents.detail.downloadButton": "Download",
  "respondents.detail.submitButton": "Einreichen",
  "respondents.detail.submitButton.RL": "Absenden",
  "respondents.detail.submitButton.BL": "Absenden",
  "respondents.detail.submitButton.AD": "Finales Einreichen",
  "respondents.detail.respondentenButton": "Respondenten hinzufügen",
  "respondents.detail.survey.period": "Erhebungszeitraum",
  "respondents.detail.run.survey": "Anzeigen und bearbeiten",
  "respondents.detail.run.survey.readOnly": "Bericht anzeigen",
  "respondents.detail.progress.description": "{count} von {total} Pflichtfragen",
  "respondents.detail.pdf": "PDF",
  "respondents.detail.change.respondent": "Veränderung Respondenten",
  "respondents.detail.change.respondent.text":
    "Durch die Änderung des verantwortlichen Respondenten kann die " +
    "Zuständigkeit für den entsprechenden Berichtsteil dargestellt werden. Die Änderung hat einen ausschließlich " +
    "informativen Charakter und löst keine technischen Beschränkungen aus.",
  "respondents.detail.submit.button.tooltip":
    "Bitte beantworten Sie alle Pflichtfragen, um den Sachbericht einreichen zu können.",
  "respondents.detail.submit.button.disabled": "Sie haben keine Berechtigung zum Einreichen des Sachberichtes.",
  "respondents.detail.status.NEW": "Neu",
    "respondents.detail.status.undefined": "Unbekannt",
  "respondents.detail.status.OBSOLETE": "Obsolet",
  "respondents.detail.status.IN_PROGRESS": "In Bearbeitung",
  "respondents.detail.status.SENT": "Eingereicht",
  "respondents.detail.status.CLOSED": "Abgeschlossen",
  "respondents.detail.status.change": "Status ändern",
  "respondents.detail.question.required.warning": "Im Bericht fehlen noch einige Pflichtangaben. Bitte klicken Sie auf die rot markierten Pfeile, um die Angaben zu vervollständigen.",
  "template.activation.title": "Berichtsvorlage aktivieren",
  "template.activation.invalid_data": "Keine Projekte vorhanden oder bereits aktiviert.",
  "template.activation.invalid_request": "Anfrage an den Service gescheitert.",
  "template.activation.template_not_in_lectorate":"Es ist nicht möglich, Berichtsvorlagen aus anderen Programmen für das Lektorenprogramm vorzuaktivieren. Wählen Sie eine Berichtsvorlage aus dem Lektorenprogramm aus.",
  "template.activation.duplicate_key":
    "Es wurden doppelte IDs gefunden. Bitte wenden Sie sich an S12.",
  "template.activation.program_must_be_choosen": "Bitte Programm wählen.",
  "template.activation.succeeded": "Ihr Erhebungsinstrument wurde erfolgreich aktiviert und kann nun für die Berichterstattung genutzt werden.",
  "template.activation.pre_activation_succeeded": "Ihr Erhebungsinstrument wurde erfolgreich voraktiviert. Lektoren und Lektorinnen können es jetzt für ihre Berichterstattung nutzen.",

  "respondents.detail.sendReminder": "Erinnerung senden",

  "manage.survey.user.title": "Respondent hinzufügen",
  "manage.survey.user.edit.title": "Respondent bearbeiten",
  "manage.survey.user.send_email": "E-Mail öffnen",
  "manage.survey.user.name": "Vorname",
  "manage.survey.user.lastname": "Name",
  "manage.survey.user.email": "E-Mail",
  "manage.survey.user.expiration.date": "Ablaufdatum",
  "manage.survey.user.link": "Link",
  "manage.survey.user.inactive.users": "Inaktive Respondenten anzeigen",
  "manage.survey.user.inactive.validity": "Gültigkeit",
  "manage.survey.user.create": "Respondent anlegen",
  "manage.survey.user.add": "Hinzufügen",
  "manage.survey.user.update": "Aktualisieren",
  "manage.survey.user.email.text":
    "Sie werden dazu eingeladen, einen Sachbericht des DAAD zu bearbeiten. Mit folgendem Link erhalten Sie temporären Zugriff auf das DAAD Monitoringtool und können den Sachbericht bearbeiten.\r\n\r\n—\r\n",
  "manage.survey.user.email.subject": "Zugriff Monitoringtool DAAD",
  "manage.survey.user.copy": "Link kopieren",
  "manage.survey.user.deactivate": "Deaktivieren",
  "manage.survey.user.deactivate.first.part":
    "Sind Sie Sicher, dass Sie den ausgewählten Respondenten deaktivieren möchten?",
  "manage.survey.user.deactivate.second.part":
    "Der Zugang wird gesperrt und der versendete Link ist ungültig. Der Respondent hat keinen Zugriff auf den Bericht.",
  "manage.survey.user.deactivate.third.part":
    "Sie können deaktivierte Benutzer wieder aktivieren, indem Sie ein neues Ablaufdatums definieren.",
  "manage.survey.user.show.link.first.part":
    "Der Respondent wurde erfolgreich angelegt und hat mit folgendem Link Zugriff auf das Monitoringtool:",
  "manage.survey.user.show.link.second.part": "Bitte versenden Sie diesen Link an den Respondenten.",
  "manage.survey.user.username.already.exists": "Diese E-Mail Adresse ist im System bereits vergeben.",
  "manage.survey.user.send.user.notification": "Benutzer per E-Mail benachrichtigen",

  "status.of.survey.send.dialog.title": "Sachbericht einreichen",
  "status.of.survey.send.dialog.title.RL": "Bericht absenden",
  "status.of.survey.send.dialog.title.AD": "Bericht einreichen",
  "status.of.survey.send.dialog.text1":
    "Sind Sie sicher, dass Sie die Bearbeitung abschließen und den Sachbericht einreichen möchten?",
  "status.of.survey.send.dialog.text1.RL":
    "Sind Sie sicher, dass Sie die Bearbeitung abschließen und den Bericht an die nächsthöhere Ebene geben wollen? Eine weitere Bearbeitung ist nur nach erneutem Freischalten durch Ihre Führungskraft möglich.",
  "status.of.survey.send.dialog.text1.AD":
    "Sind Sie sicher, dass Sie die Bearbeitung abschließen möchten? Nach Einreichen des Berichts sind keine Änderungen mehr möglich.",
  "status.of.survey.send.dialog.text2": "Nach Einreichen des Sachberichts sind keine Änderungen mehr möglich.",
  "status.of.survey.send.dialog.text2.RL":
    "Bevor Sie die Angaben senden, haben Sie die Möglichkeit ein PDF des jetzigen Standes herunterzuladen.",
  "status.of.survey.send.dialog.text2.AD":
    "Bevor Sie Ihre Angaben senden, haben Sie die Möglichkeit ein PDF Ihres Berichts herunterzuladen.",
  "status.of.survey.change.status.dialog.text1":
    "Bitte setzen Sie den Status nach erfolgreicher Prüfung des Sachberichts auf „Abgeschlossen“. ",
  "status.of.survey.change.status.dialog.text2":
    "Um die Bearbeitung des Sachberichts wieder zu ermöglichen, setzen Sie den Status auf „In Bearbeitung“.",
  "status.of.survey.change.status.dialog.text2.BL":
    "Um die Bearbeitung des Berichts durch die Ihnen zugeordnete Arbeitseinheit wieder zu ermöglichen, setzen Sie den Status auf „In Bearbeitung“. So können Anpassungen aus Ihrer Prüfung durch die Autorin/ den Autor selbst eingefügt werden.",
  "status.of.survey.change.status.dialog.obsolete.text1":
    "Sie können den Status auf „Obsolet“ setzen, wenn der bereits aktivierte Sachbericht nicht bearbeitet und eingereicht werden soll.",
  "status.of.survey.change.status.dialog.obsolete.text2":
    "Achtung: Dieser Vorgang kann nicht rückgängig gemacht werden.",
  "status.of.survey.change.status.confirm.dialog.text": "Sind Sie sicher, dass Sie den Status ändern möchten?",
  "status.of.survey.send.dialog.info":
    "Sie haben {totalProgress}% der Fragen beantwortet. Bitte tragen Sie zu einer besseren Datenqualität bei, indem Sie alle Fragen des Sachberichts beantworten.",

  "evaluation.title": "Auswertung",
  "evaluation.tabs.indicators": "Standardindikatoren",
  "evaluation.tabs.programs": "Programmauswertung",
  "evaluation.tabs.projects": "Projekte",
  "evaluation.tabs.achievement": "Zielerreichung",

  "heartbeat.jwt.verification":
    "Ihre Sitzung wurde beendet. Bitte melden Sie sich erneut über das DAAD Portal oder mit Ihren Nutzerdaten an.",

  "master.data.management.page.title": "Stammdatenverwaltung",
  "master.data.management.master.data": "Stammdaten",
  "master.data.management.funding.area": "Förderbereich",
  "master.data.management.program": "Programm",
  "master.data.management.program.table.numerical": "Numerisch",
  "master.data.management.program.table.percentage": "Prozentual",
  "master.data.management.program.instance": "Programminstanz",
  "master.data.management.program.instances": "Programminstanz(en)",
  "master.data.management.project": "Projekt",
  "master.data.management.lectorate":"Standort",
  "master.data.management.edit": "Bearbeiten",
  "master.data.management.new.program": "Programm anlegen",
  "master.data.management.new.program.instance": "Programminstanz anlegen",
  "master.data.management.new.project": "Projekt anlegen",
  "master.data.management.edit.program": "Programm bearbeiten",
  "master.data.management.edit.program.instance": "Programminstanz bearbeiten",
  "master.data.management.edit.project": "Projekt bearbeiten",
  "master.data.management.program.name": "Name",
  "master.data.management.project.university": "Hochschule",
  "master.data.management.project.targetRegion": "Region",
  "master.data.management.project.targetCountry": "Land",
  "master.data.management.project.projectType": "Typ",
  "master.data.management.program.instance.name": "Name",
  "master.data.management.project.name": "Name",
  "master.data.management.button.save": "Speichern",
  "master.data.management.button.cancel": "Abbrechen",
  "master.data.management.button.successfully.save": "Erfolgreich gespeichert",
  "master.data.management.funding.area.foreignId": "ID Förderbereich",
  "master.data.management.program.foreignid": "PKZ",
  "master.data.management.program.code": "Kürzel (Code)",
  "master.data.management.program.instance.foreignid": "FPI",
  "master.data.management.project.foreignid": "Projekt-ID",
  "master.data.management.lectorate.foreignid": "Standort-ID",
  "master.data.management.confirm.delete.project": "Bitte bestätigen Sie das Löschen des Projekts.",
  "master.data.management.confirm.delete.program.instance": "Bitte bestätigen Sie das Löschen der Programminstanz.",
  "master.data.management.confirm.delete.program": "Bitte bestätigen Sie das Löschen des Programms.",
  "master.data.management.button.successfully.delete": "Erfolgreich gelöscht.",
  "master.data.management.project.cannot.be.deleted":
    "Das Projekt kann nicht gelöscht werden, da schon Sachberichte existieren.",
  "master.data.management.project.deletion.not.possible": "Löschen nicht möglich",
  "master.data.management.project.active": "Aktiv",
  "master.data.management.project.obsolet": "Obsolet",
  "master.data.management.table.only.active.projects": "Nur aktive Projekte anzeigen",

  "role.management.page.title": "Rollen Verwaltung",
  "role.management.table.column.name": "Name",
  "role.management.table.column.title": "Titel",
  "role.management.table.column.permissions": "Berechtigungen",
  "role.management.table.column.scope": "Zuweisungsebene",
  "role.management.new.role": "Rolle anlegen",
  "role.management.role.name": "Name",
  "role.management.role.title.german": "Titel (deutsch)",
  "role.management.role.title.english": "Titel (englisch)",
  "role.management.create.new.role": "Neue Rolle anlegen",
  "role.management.edit.role": "Rolle bearbeiten",
  "role.management.available.permissions": "Verfügbare Berechtigungen",
  "role.management.assigned.permissions": "Zugewiesene Berechtigungen",
  "role.management.confirm.delete.role": "Bitte bestätigen Sie das Löschen der Rolle.",
  "role.management.role.scope.project": "Projekt",
  "role.management.role.scope.program": "Programm",
  "role.management.role.scope.programInstance": "Programminstanz",
  "role.management.role.scope.fundingarea": "Förderbereich",
  "role.management.role.scope": "Zuweisungsebene",

  "user.management.page.title": "Benutzerverwaltung",
  "user.management.new.user": "Benutzer anlegen",
  "user.management.table.username": "Benutzername (Email-Adresse)",
  "user.management.table.firstname": "Vorname",
  "user.management.table.lastname": "Nachname",
  "user.management.table.employeeNumber": "PKZ (optional)",
  "user.management.table.roles": "Rollen",
  "user.management.table.permissions": "Berechtigungen",
  "user.management.table.permissions.hint":
    "Weisen Sie Berechtigungen zu oder heben Sie die Zuweisung auf, indem Sie die entsprechenden Schaltflächen verwenden oder sie per Drag & Drop in das entsprechende Feld ziehen.",
  "user.management.table.units": "Units",
  "user.management.table.status": "Status",
  "user.management.table.active": "Aktiv",
  "user.management.table.only.active.users": "nur aktive Benutzer anzeigen",
  "user.management.table.only.unnotified.users": "nur Benutzer ohne Account Benachrichtigung",
  "user.management.search.placeholder": "Suche in Benutzerverwaltung...",
  "user.management.search.aria": "Suche in Benutzerverwaltung",
  "user.management.action.activate": "Aktivieren",
  "user.management.action.deactivate": "Deaktivieren",
  "user.management.create.new.user": "Neuen Nutzer anlegen",
  "user.management.create.new.user.password": "Passwort",
  "user.management.create.new.user.administrator": "Administrator",
  "user.management.create.new.user.save": "Speichern",
  "user.management.create.new.user.cancel": "Abbrechen",
  "user.management.create.new.user.password.warning":
    "Passwort muss zwischen {MIN_PASSWORD_CHARS} und {MAX_PASSWORD_CHARS} Zeichen lang sein.",
  "user.management.create.new.user.username.warning":
    "Bitte geben Sie eine gültige Email-Adresse als Benutzernamen an.",
  "user.management.user.activate": "Möchten Sie den Nutzer {username} aktivieren?",
  "user.management.user.deactivate":
    "Durch das Deaktivieren werden alle Berechtigungen des Benutzers gelöscht. Möchten Sie den Nutzer {username} deaktivieren?",
  "user.management.edit.user": "Nutzer bearbeiten",
  "user.management.edit.send.user.account.notification": "Benutzer Account Benachrichtigung versenden",
  "user.management.edit.send.user.account.notification.confirm":
    "Bitte bestätigen Sie den Versand der Benachrichtigungs E-Mail",
  "user.management.create.new.user.exists.warning": "Benutzer ist bereits vorhanden.",
  "user.management.create.new.role.exists.warning": "Rolle ist bereits vorhanden.",
  "user.management.create.new.user.available.roles": "Verfügbare Rollen",
  "user.management.create.new.user.roles": "Benutzer Rollen",
  "user.management.users.per.page": "Benutzer",
  "user.management.edit.effective.permissions": "Effektive Berechtigungen",
  "user.management.role.assignments": "Rollenzuordnung",
  "user.management.history.title": "Berechtigungshistorie",
  "user.management.history.loading": "Historie wird geladen …",
  "user.management.history.empty": "Es sind noch keine Änderungen protokolliert.",
  "user.management.history.date": "Zeitpunkt",
  "user.management.history.change": "Änderung",
  "user.management.history.change.ASSIGNED": "Zugewiesen",
  "user.management.history.change.ROLE_CHANGED": "Rolle geändert",
  "user.management.history.change.REVOKED": "Entzogen",
  "user.management.history.change.USER_DEACTIVATED": "Benutzer deaktiviert",
  "user.management.history.change.USER_ACTIVATED": "Benutzer aktiviert",
  "user.management.history.source": "Quelle",
  "user.management.history.source.MANUAL": "Benutzerverwaltung",
  "user.management.history.source.SAP": "SAP",
  "user.management.history.source.BULK_IMPORT": "Bulk-Import",
  "user.management.history.source.SYSTEM": "System",
  "user.management.history.actor": "Geändert durch",
  "user.management.choose.role": "Rolle auswählen",

  "user.management.roles.admin": "Administrator;",
  "user.management.roles.evaluation_ind_viewer": "Auswertung Indikatoren anzeigen;",
  "user.management.roles.evaluation_obj_viewer": "Auswertung Zielerreichung anzeigen;",
  "user.management.roles.evaluation_prg_viewer": "Auswertung Programme anzeigen;",
  "user.management.roles.evaluation_prj_viewer": "Auswertung Projekte anzeigen;",
  "user.management.roles.evaluation_viewer": "Navigation Auswertung anzeigen;",
  "user.management.roles.indicator_viewer": "Navigation Indikatoren anzeigen;",
  "user.management.roles.survey_viewer": "Navigation Berichterstattung anzeigen;",
  "user.management.roles.template_creator": "Erhebungsinstrumente bearbeiten;",
  "user.management.roles.template_viewer": "Navigation Erhebungsinstrumente anzeigen;",
  "user.management.roles.user": "Benutzer;",
  "user.management.roles.user_editor": "Benutzer verwalten;",
  "user.management.roles.user_viewer": "Benutzer anzeigen;",
  "user.management.roles.indicator_editor": "Indikatoren anzeigen;",
  "user.management.roles.temporary_user": "Temporärer Benutzer;",
  "user.management.roles.library_viewer": "Bibliothek anzeigen;",
  "user.management.roles.library_editor": "Bibliothek verwalten;",
  "user.management.roles.program_admin": "Programm Administrator;",
  "user.management.roles.master_data_viewer": "Stammdaten anzeigen;",
  "user.management.roles.master_data_editor": "Stammdaten bearbeiten;",
  "user.management.roles.role_editor": "Rollen bearbeiten;",
  "user.management.roles.survey_submitter": "Sachbericht einreichen;",
  "user.management.roles.survey_key_editor": "Fragen-IDs bearbeiten;",
  "user.management.roles.survey_editor": "Sachbericht bearbeiten;",
  "user.management.roles.survey_respondent_editor": "Respondenten bearbeiten;",
  "user.management.please.choose.a.project": "Bitte Projekt auswählen",
  "user.management.please.choose.a.unit": "Organ. Einheit auswählen",

  "pagination.page": "Seite",
  "pagination.of": "von",
  "pagination.previous": "Zurück",
  "pagination.next": "Weiter",
  "pagination.showing": "Seite {current} von {total}",

  "table.chart.chose.program": "Bitte wählen Sie ein Programm, um die Statistik anzuzeigen.",
  "indicator.chart.choose.funding.area": "Bitte wählen Sie einen Förderbereich aus.",
  "indicator.chart.choose.group": "Bitte wählen Sie einen Indikator aus.",
  "indicator.chart.choose.time_facet": "Bitte wählen Sie mindestens einen Berichtszeitraum aus.",
  "indicator.chart.changed.filter.criteria":
    "Bitte wenden Sie die geänderten Filterkriterien an, um die Ansicht zu aktualisieren",
  "indicator.chart.legend": "Legende",
  "indicator.chart.legend.report.amount": "Anzahl ausgewerteter Berichte",
  "indicator.chart.legend.project.amount": "Anzahl der Berichte, in denen die Frage beantwortet wurde",
  "indicator.chart.legend.results.sum": "Summe der Nennungen",
  "collapsible.program.required": "Bitte wählen Sie einen Förderbereich und ein Programm aus.",
  "collapsible.program.instance.required": "Bitte wählen Sie mindestens eine Programminstanz aus.",
  "collapsible.question.group.required": "Bitte wählen Sie einen Abschnitt aus.",
  "collapsible.no.question.groups.found": "Es sind keine Berichte vorhanden für die angewendeten Filterkriterien.",
  "collapsible.year.required":
    "Bitte wählen Sie mindestens einen Berichtszeitraum aus, und passen Sie gegebenenfalls die Auswahl der Programminstanz(en) an",
  "collapsible.changed.filter.criteria":
    "Bitte klicken Sie auf „Filterkriterien anwenden“, um Ihre Auswahl zu bestätigen. Bitte beachten Sie, dass dabei die Option „seit Förderbeginn“ für alle Fragen zurückgesetzt wird.",
  "collapsible.download.downloadAll": "Statische Daten exportieren",
  "collapsible.download.downloadAll.helperText":
    "Beinhaltet für jedes Projekt eine Zeile mit allen statischen Daten aus folgenden Fragetypen: Auswahl mehrfach, Auswahl einfach, Zahlenfeld, Matrix, Datum, statische Tabelle. \n" +
    "Antworten aus Textfeldern finden sich in einer separaten Datei (Button: „Textboxen und -felder exportieren“). Daten der dynamischen Tabellen finden sich in den Einzeldateien des Gesamtdownloads (Button: „Alle Daten exportieren (ZIP)“).",
  "collapsible.download.downloadTexts": "Textboxen und -felder exportieren",
  "collapsible.download.downloadTexts.helperText":
    "Beinhaltet für jedes Projekt eine Zeile mit den Antworten der Textboxen und -feldern außerhalb von Tabellenfragen. Textfelder innerhalb von Tabellen finden sich in den statischen Daten (Button: „Statische Daten exportieren“) bzw. den Daten der dynamischen Tabellen (Button: „Alle Daten exportieren (ZIP)).",
  "collapsible.download.downloadZip": "Alle Daten exportieren (ZIP)",
  "collapsible.download.downloadZip.helperText":
    "Beinhaltet eine ZIP-Datei mit allen Daten, exportiert in verschiedene Dateien: eine Datei mit den statischen Daten, eine Datei mit den Antworten in Textfeldern sowie für jede dynamische Tabelle eine Datei. ",
  "collapsible.download.downloadPdf": "Sachberichte (PDF) herunterladen",
  "collapsible.download.downloadPdf.helperText":
    "Beinhaltet eine ZIP-Datei mit allen Sachberichten als einzelne Dateien für den ausgewählten Zeitraum im PDF-Format.",
  "collapsible.download.downloadAAPdf": "AA-Berichte herunterladen (PDF)",
  "collapsible.download.downloadAAPdf.helperText":
    "Beinhaltet eine ZIP-Datei mit allen Sachberichten für den ausgewählten Zeitraum im PDF-Format zur Weitergabe an das Auswärtige Amt.",
  "collapsible.download.downloadRueckPdf": "Übergabe-Berichte herunterladen (PDF)",
  "collapsible.download.downloadRueckPdf.helperText":
    "Beinhaltet eine ZIP-Datei mit allen Sachberichten für den ausgewählten Zeitraum im PDF-Format, allerdings nur mit den Antworten für jene Fragen, die für die Übergabe an den neuen Lektor oder die neue Lektorin gestellt wurden.",
  "collapsible.table.nodata": "Keine Daten für die ausgewählten Filterkriterien gefunden.",
  "collapsible.filter.reportingYear": "Berichtszeitraum",
  "collapsible.filter.reportingYear.info":
    "Es werden nur Sachberichte ausgewertet, die für die ausgewählten Berichtszeiträume eingereicht wurden.",
  "collapsible.filter.reportingYear.warning":
    "Es wurden nicht für alle angefragten Berichtszeiträume Daten gefunden! Daten liegen für folgende Berichtszeiträume vor: ",
  "collapsible.filter.reportingYear.warningTitle":
    "Der Titel dieser Frage hat sich in den ausgewählten Berichtszeiträumen geändert.",
  "collapsible.filter.status": "Nur eingereichte Berichte",
  "collapsible.filter.finalReport": "Nur Abschlussberichte",
  "collapsible.filter.sinceFundingStarted": "seit Förderbeginn",
  "collapsible.filter.sinceFundingStarted.text":
    "Durch Aktivieren dieser Option werden von jedem Projekt nur die Werte des letzten vorliegenden Sachberichtes ausgegeben. Aktivieren Sie diese Funktion bei Fragen bzw. Indikatoren, die „seit Förderbeginn“ abgefragt werden, um Doppelzählungen zu vermeiden. Bei Indikatoren, die „im Berichtszeitraum“ abgefragt werden, ist diese Option nicht einzusetzen.",
  "collapsible.filter.projectCount": "Anzahl ausgewählter Berichte: ",
  "collapsible.filter.surveyTemplates": "Verwendete Berichtsvorlagen",
  "collapsible.table.question.group": "Abschnitte",
  "collapsible.table.question.group.template.info": "Die Abschnittsstruktur entspricht der Vorlage: {name}, Version {version}.",
  "collapsible.table.question.group.previous.templates": "Fragen aus früheren Vorlagen",
  "collapsible.table.question.total": "Gesamt",
  "collapsible.table.label.table": "Tabelle",
  "collapsible.table.label.chart": "Diagramm",
  "collapsible.filter.pivot.button.name": "Kreuztabellen",
  "collapsible.filter.pivot.button": "Kreuztabelle bilden",
  "collapsible.filter.pivot.button.project": "Kreuztabelle Projekt",
  "collapsible.filter.pivot.button.reporting.year": "Kreuztabelle Berichtszeitraum",
  "collapsible.filter.pivot.button.region": "Kreuztabelle Region",
  "collapsible.filter.pivot.button.country": "Kreuztabelle Land",
  "collapsible.filter.pivot.modal.title": "Kreuztabellen Auswahl",
  "collapsible.filter.pivot.modal.section": "Abschnitt auswählen",
  "collapsible.filter.pivot.modal.question": "Frage auswählen",
  "collapsible.filter.pivot.modal.field": "Feld auswählen",
  "collapsible.filter.pivot.modal.field.total": "gesamte Tabelle",
  "collapsible.table.chart": "Chart",
  "collapsible.no.reports.for.selection.warning": "Keine Berichte für die aktuelle Auswahl.",
  "evaluation.tabs.collapsible": "Programmauswertung",
  "collapsible.table.question.number.of.rows": "Anzahl Einträge",
  "indicator.chart.apply.filters": "Filterkriterien anwenden",

  "question.library.set.question.name": "Titel der Frage",
  "question.library.set.question.id": "ID",
  "question.library.toolbox": "Indikatoren-Toolbox",
  "question.library.toolbox.my": "Meine Fragenbibliothek",
  "section.library.title": "Meine Abschnittsbibliothek",
  "library.savedAt": "Gespeichert am",
  "library.elementTitle": "Titel",
  "library.origin": "Ursprüngliche Vorlage",
  "library.insertSelected": "Auswahl einfügen",
  "library.delete": "Löschen",
  "library.questionPreview": "Fragen anzeigen",
  "section.library.saveCurrent": "Aktuellen Abschnitt speichern",
  "section.library.save": "In Abschnittsbibliothek speichern",
  "section.library.saveAction": "In Bibliothek speichern",
  "survey.editor.page.visibility": "Sichtbarkeit",
  "survey.editor.page.visible": "Abschnitt sichtbar",
  "section.library.name": "Abschnittstitel in der Bibliothek",
  "section.library.sourceTemplate": "Gespeichert aus Vorlage",
  "section.library.sourceTemplateUnknown": "Unbekannt",
  "section.library.questions": "Anzahl Fragen",
  "section.library.actions": "Aktionen",
  "section.library.empty": "Sie haben noch keine Abschnitte gespeichert.",
  "section.library.loading": "Abschnittsbibliothek wird aktualisiert …",
  "section.library.saved": "Der Abschnitt wurde in Ihrer Bibliothek gespeichert.",
  "section.library.error": "Die Anfrage konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.",
  "section.library.insert": "Abschnitt einfügen",
  "section.library.delete": "Löschen",
  "section.library.deleteConfirm": "Abschnitt „{name}“ aus Ihrer Bibliothek löschen? Bereits eingefügte Kopien bleiben erhalten.",
  "section.library.copyHint": "Der Abschnitt wird mit allen Fragen als Kopie in die aktuelle Vorlage eingefügt. Prüfen Sie nach dem Einfügen ggf. Trigger und Sichtbarkeiten.",
  "section.library.keyCollision": "Beim Einfügen entstehen doppelte Abschnitt- oder Frage-IDs. Bitte prüfen und beheben Sie die Doppelungen sowie betroffene Trigger in der Vorlage.",
  "section.library.externalTriggers": "Dieser Abschnitt enthält Trigger mit Zielen außerhalb des Abschnitts. Diese Ziele werden nicht mitkopiert. Bitte ordnen Sie die betroffenen Trigger nach dem Einfügen im Editor neu zu und prüfen Sie die Sichtbarkeit des Abschnitts und seiner Fragen.",
  "question.library.toolbox.library": "Fragenvorlagen auswählen",
  "question.library.toolbox.custom": "Fragen individuell erstellen",
  "survey.editor.add.question.library.title": "Indikatoren-Toolbox",
  "survey.editor.add.question.library.title.my": "Meine Fragenbibliothek",
  "survey.editor.edit.question.library.title": "Frage bearbeiten",
  "survey.editor.add.question": "Hinzufügen",
  "survey.editor.add.question.question.title": "Fragetitel",
  "survey.editor.add.question.question.origin": "Gespeichert aus",
  "survey.editor.add.question.question.type": "Typ",
  "question.library": "Fragenbibliothek",
  "question.library.all": "Alle",
  "question.library.preview.image": "Vorschaubild",

  "question.library.language.text": "Textfeld",
  "question.library.language.date": "Datum",
  "question.library.language.comment": "Textbox",
  "question.library.language.infoMessage": "Infotext",
  "question.library.language.checkbox": "Auswahl mehrfach",
  "question.library.language.radio": "Auswahl einfach",
  "question.library.language.dropdown": "Dropdown",
  "question.library.language.predefinedList": "Vordefinierte Liste",
  "question.library.language.number": "Zahl",
  "question.library.language.matrixSingleChoice": "Matrix einfach",
  "question.library.language.matrixMultipleChoice": "Matrix mehrfach",
  "question.library.language.staticTable": "Statische Tabelle",
  "question.library.language.staticTable.cols": "Spaltenansicht",
  "question.library.language.staticTable.rows": "Zeilenansicht",
  "question.library.language.dynamicTable": "Dynamische Tabelle",
  "question.library.deletion.not.possible.dialog.title": "Löschen nicht möglich",
  "question.library.deletion.not.possible.dialog.message":
    "Die Frage konnte nicht gelöscht werden, da sie bereits in mindestens einem Indikator verwendet wird",
  "question.library.deletion.confirm.referencing.templates.title": "Löschen bestätigen",
  "question.library.deletion.confirm.referencing.templates.message":
    "Die Frage wird bereits in mindestens einem Erhebungsinstrument verwendet. Möchten Sie die Frage trotzdem aus “Meine Fragenbibliothek” löschen?",
  "question.library.question.id.invalid": "Diese ID ist schon vergeben",

  "app.error.unknown": "Es ist ein unbekannter Fehler während der Verabeitung aufgetreten.",

  "user.profile.page.title": "Mein Profil",
  "user.profile.form.firstname": "Vorname",
  "user.profile.form.lastname": "Nachname",
  "user.profile.update.password.dialog.title": "Passwort ändern",
  "user.profile.form.current.password": "Aktuelles Passwort",
  "user.profile.form.new.password": "Neues Passwort",
  "user.profile.form.new.password.confirm": "Neues Passwort (Bestätigung)",
  "user.profile.form.new.password.invalid.message":
    "Passwort muss zwischen {MIN_PASSWORD_CHARS} und {MAX_PASSWORD_CHARS} Zeichen lang sein.",
  "user.profile.form.new.password.confirm.invalid.message": "Die Passwort Bestätigung stimmt nicht überein.",
  "user.profile.button.change.password": "Password ändern",
  "user.profile.reponse.error.current.password.incorrect": "Das aktuelle Passwort ist nicht korrekt",
  "user.profile.message.password.change.successful": "Sie haben Ihr Passwort erfolgreich geändert.",

  "question.preview": "Vorschau Abfrage",

  "table.dialog.previousRow": "Vorherige Zeile",
  "table.dialog.nextRow": "Nächste Zeile",

  "temporary.user.create.error":
    "Der temporäre Benutzer konnte nicht angelegt werden, da der Benutzername bereits für ein reguläres Benutzerkonto verwendet wird.",

  "template.question.sync.dialog.title": "Fragen synchronisieren",
  "template.question.sync.dialog.message":
    "Sie sind im begriff, die in der Vorlage geänderten Fragen in die Fragenbibliothek zu synchronisieren. Möchten Sie fortfahren?",

  "survey.version.compare.page": "Abschnitt",
  "survey.version.compare.question": "Frage",
  "survey.version.compare.rowCol": "Spalte/Zeile",
  "survey.version.compare.rows": "Zeilen",
  "survey.version.compare.columns": "Spalten",
  "survey.version.compare.choice": "Option",
  "survey.version.compare.type": "Typ",
  "survey.version.compare.key": "Schlüssel",
  "survey.version.compare.change": "Änderung",
  "survey.version.compare.type.DynamicTable": "dynamische Tabelle",
  "survey.version.compare.type.StaticTable": "statische Tabelle",
  "survey.version.compare.type.PredefinedList": "vordefinierte Liste",
  "survey.version.compare.type.Text": "Text",
  "survey.version.compare.type.Number": "Nummer",
  "survey.version.compare.type.Radio": "Radio",
  "survey.version.compare.type.Checkbox": "Checkbox",
  "survey.version.compare.type.Dropdown": "Dropdown",
  "survey.version.compare.type.MatrixSingleChoice": "Matrix einfache Auswahl",
  "survey.version.compare.type.MatrixMultipleChoice": "Matrix mehrfache Auswahl",
  "survey.version.compare.type.Comment": "Kommentar",
  "survey.version.compare.type.Date": "Datum",
  "survey.version.compare.type.Upload": "Upload",
  "survey.version.compare.type.ProjectData": "Projektdaten",
  "survey.version.compare.type.InfoMessage": "Info Nachricht",
  "survey.version.compare.change.new": "Neu",
  "survey.version.compare.change.deleted": "gelöscht",
  "survey.version.compare.change.typeChange": "Typ geändert",
  "survey.version.compare.change.nameChange": "Name geändert",
  "survey.version.compare.change.otherChange": "Änderungen liegen vor",
  "survey.version.compare.current": "Aktuell",
  "survey.version.compare.view.pages": "Nach Abschnitten",
  "survey.version.compare.view.questions": "Nur Fragen",
  "survey.version.compare.expand.all.pages": "Alle Abschnitte aufklappen",
  "survey.version.compare.collapse.all.pages": "Alle Abschnitte zuklappen",
  "survey.version.compare.expand.all.questions": "Alle Fragen aufklappen",
  "survey.version.compare.collapse.all.questions": "Alle Fragen zuklappen",
  "survey.version.compare.warning.duplicate.page.keys": "Doppelte Abschnitt-IDs liegen vor. Der Vergleich verwendet Abschnitt-IDs als Schlüssel; doppelte Abschnitt-IDs können daher nicht eindeutig zugeordnet werden.",
  "survey.version.compare.warning.duplicate.keys": "Doppelte IDs liegen vor. Wenden Sie sich an S12"
};
export default de;
